<button mat-icon-button class="hidden mr-20 p-0-i w-auto-i float-left-sm">
  <mat-icon class="m-10 clr-ddark">menu</mat-icon>
</button>
<a href="{{ homeRoute }}" class="d-inline-block m-r-20 float-right-sm mt-5"
  ><img src="./assets/images/mpz-logo.svg" class="logo"
/></a>
